import {EntityManagePage} from "base/entity";
import {useConfigModule} from "base/provider";

const ManageSubaglomeracionPage = () => {
    const {moduleFilter} = useConfigModule();

    return <EntityManagePage filter={moduleFilter}></EntityManagePage>;
};
export default ManageSubaglomeracionPage;
